import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { getOverallRank } from "./overall-rank.api";
import type { GetOverallRankResponse } from "./overall-rank.type";

// Query keys
export const overallRankKeys = {
  all: ["overall-rank"] as const,
  detail: (symbol: string) => [...overallRankKeys.all, symbol] as const,
};

// Get overall rank by symbol query
export const useOverallRank = (
  symbol: string,
  options?: {
    tabAccessToken?: string;
  } & Omit<
    UseQueryOptions<GetOverallRankResponse, Error>,
    "queryKey" | "queryFn"
  >
) => {
  const { tabAccessToken, ...queryOptions } = options ?? {};
  return useQuery({
    queryKey: overallRankKeys.detail(symbol),
    queryFn: () => getOverallRank(symbol, tabAccessToken),
    enabled: (queryOptions?.enabled ?? true) && !!symbol && !!tabAccessToken,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    ...queryOptions,
  });
};

